export default __webpack_public_path__ + "static/media/fingerprint-animate.7308b6f8.svg";